import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '../../accordion/accordion';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Security } from '../../icons';
import { EVENT_FAQ_CONST, EVENT_FAQ_ANSWERS_CONST } from '../data/constants';
import { eventFaqDefinition, miscEventFaqDefinitions, category_labels, formattedMiscEventFaqDefinitions } from '../data/eventFaqDefinition';
import { getFormattedTime } from '../../search-module/components/date-time/mobile/helpers/helpers';

const EventRulesContent = ({ faqData = {}, hasValidEndTime, hasFlexibleHours, hasEventRules, selectedEventRules, hasOtherEventRules, prohibitedEventRules, intl }) => {
  const { HOURS_ADJUSTED_UPON_REQUEST, HAS_NO_FLEXIBLE_HOURS } = EVENT_FAQ_ANSWERS_CONST;
  const { HAS_FLEXIBLE_HOURS, ARE_TICKETED_EVENTS_ALLOWED } = EVENT_FAQ_CONST;
  const label = <FormattedMessage
    id={category_labels.rules.id}
    defaultMessage={category_labels.rules.defaultMessage}
  />;
  return (
    <div className="EventFAQ">
      <Accordion
        header={
          <div className="flex middle">
            <Security height={24} width={24} className="margin-sm-right" />
            <div className="h6 margin-md-left padding-xs-top padding-xs-bottom faq-section">{label}</div>
          </div>
        }
        onOpenCallback={() => {
          analyticsIntegrations.trackEvent('Listing section expanded', {
            user_id: faqData.userID,
            listing_id: faqData.listingID,
            section: 'Event Rules'
          });
        }}
      >
        <div className="event-faq-section padding-md-bottom">
          {
            hasValidEndTime &&
              <div className="margin-lg-bottom section-indent">
                <div>
                  <div className="faq-label heavier margin-lg-bottom">
                    {intl.formatMessage(miscEventFaqDefinitions.quiet_hours_header)}
                  </div>
                  <div className="faq-label margin-lg-bottom">
                    {intl.formatMessage(eventFaqDefinition.event_rules.loud_music_ends_by)}
                    &nbsp;
                    {getFormattedTime(faqData.loud_music_ends_by, intl)}
                  </div>
                  <div className="faq-label text-gray-600 bg-gray-100 margin-lg-bottom text-small padding-md">
                    {formattedMiscEventFaqDefinitions.loud_music_warning}
                  </div>
                </div>
                {(hasFlexibleHours || hasEventRules) && <hr />}
              </div>
          }
          {
            hasFlexibleHours &&
              <div className="margin-lg-bottom section-indent">
                <div>
                  <div className="faq-label heavier margin-lg-bottom">
                    {intl.formatMessage(miscEventFaqDefinitions.flexible_hours)}
                  </div>
                  <div className="faq-label margin-lg-bottom">
                    {
                      HOURS_ADJUSTED_UPON_REQUEST === faqData[HAS_FLEXIBLE_HOURS]
                        ? intl.formatMessage(eventFaqDefinition.event_rules[HAS_FLEXIBLE_HOURS][HOURS_ADJUSTED_UPON_REQUEST])
                        : intl.formatMessage(eventFaqDefinition.event_rules[HAS_FLEXIBLE_HOURS][HAS_NO_FLEXIBLE_HOURS])
                    }
                  </div>
                </div>
                {hasEventRules && <hr />}
              </div>
          }
          {
            hasEventRules &&
          <div className='section-indent'>
            <div className="faq-label heavier margin-md-bottom">
              {intl.formatMessage(miscEventFaqDefinitions.event_rules_header)}
            </div>
            {0 < selectedEventRules.length && selectedEventRules.map((rule, key) => (
              <div className="faq-label margin-md-bottom" key={key}>
                {intl.formatMessage(eventFaqDefinition.event_rules.rules_restriction[rule])}
              </div>))}
            {hasOtherEventRules &&
              <div>
                <div className="faq-label margin-md-bottom">
                  {faqData.other_event_rules}
                </div>
              </div>
            }
            {
              0 < prohibitedEventRules.length && prohibitedEventRules.map((rule, key) => (
                <div className="faq-label text-gray-500 margin-md-bottom strike-through" key={key}>
                  {intl.formatMessage(eventFaqDefinition.event_rules.rules_restriction[rule])}
                </div>
              ))
            }
            { faqData.hasOwnProperty(ARE_TICKETED_EVENTS_ALLOWED)
            && <div className="faq-label text-gray-600 bg-gray-100 margin-lg-bottom text-small padding padding-md">
              {formattedMiscEventFaqDefinitions.residential_warning}
            </div>
            }
          </div>
          }
        </div>
      </Accordion>
    </div>
  );
};

EventRulesContent.propTypes = {
  faqData: PropTypes.object,
  hasValidEndTime: PropTypes.bool,
  hasFlexibleHours: PropTypes.bool,
  hasEventRules: PropTypes.bool,
  selectedEventRules: PropTypes.array,
  hasOtherEventRules: PropTypes.array,
  prohibitedEventRules: PropTypes.array,
  intl: PropTypes.object
};

export default injectIntl(EventRulesContent);
